





























































































































































































import Vue from 'vue'

import { dataGridHeaders, desserts } from '../example-data'

const sandboxTemplateHTML =
`<v-adv-data-table
 :dense = "dense"
 :showSelect = "showSelect"
 :items="items"
 :headers="dataGridHeaders"
 :dark = "dark"
          >
          <template v-if="customSlots" v-slot:header.fat="{ header }">
            <v-icon color ="red">mdi-cake</v-icon>
          </template>
          <template v-if="customSlots" v-slot:item.calories="{ item }">
            <v-chip :color="getColor(item.calories)" dark>{{ item.calories }}</v-chip>
          </template>
          <template v-if="customSlots" v-slot:item.fat="{ item }">
            <v-chip :color="getColorFat(item.fat)" dark>{{ item.fat }}</v-chip>
          </template>
</v-adv-data-table>`

const sandboxCode =
`export default ({
  data: () => ({
    items: desserts, // see items
    dataGridHeaders: dataGridHeaders, // see headers
    multiple: false,
    dense: false,
    dark: false,
    customSlots: false,
  }),
  methods: {
    getColor (calories) {
      if (calories > 400) return "red"
      else if (calories > 200) return "orange"
      else return "green"
    },
    getColorFat (fat: any) {
      if (fat > 20) return "red"
      else if (fat > 10) return "orange"
      else return "green"
    }
  }
})`

export default Vue.extend({
  data: () => ({
    items: desserts,
    headers: dataGridHeaders,
    showSelect: true,
    singleSelect: false,
    dense: false,
    dark: false,
    customSlots: false,
    filterIcon: 'mdi-text-subject',
    filterIconColor: 'red',
    filterActiveIconColor: 'green',
    folderIcon: 'folder',
    folderOpenIcon: 'folder-open',
    itemIcon: 'file',
    itemIconColor: 'cyan',
    folderIconColor: 'amber',

    codeSandbox: false,
    sandboxTemplate: sandboxTemplateHTML,
    sandboxCode: sandboxCode

  }),
  methods: {
    getColor (calories: any) {
      if (calories > 400) return 'red'
      else if (calories > 200) return 'orange'
      else return 'green'
    },
    getColorFat (fat: any) {
      if (fat > 20) return 'red'
      else if (fat > 10) return 'orange'
      else return 'green'
    }
  }
})
